var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{staticClass:"pc-radio-group",attrs:{"disabled":_vm.disabled,"label":_vm.label,"id":_vm.id,"rules":_vm.rules,"row":_vm.row},on:{"change":function($event){return _vm.$emit('change')}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }